module.exports = __webpack_public_path__ + "img/fuseikai.bd8e6b1e.png";